import { render } from "./Receipts.vue?vue&type=template&id=254f95e2"
import script from "./Receipts.vue?vue&type=script&lang=js"
export * from "./Receipts.vue?vue&type=script&lang=js"
script.render = render

export default script